import { ActionImage } from './ActionImage';

export { ActionImage };
